import React, { PureComponent } from "react";
import * as PIXI from "pixi.js";
import styled from "styled-components";
const feather6Img = `${process.env.PUBLIC_URL}/assets/images/star.png`;

const StarStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

const randomizeStar = (star, initial) => {
  star.z = initial ? Math.random() * 2000 : cameraZ + Math.random() * 1000 + 2000;

  //Calculate star positions with radial random coordinate so no star hits the camera.
  const deg = Math.random() * Math.PI * 2;
  const distance = Math.random() * 50 + 1;
  star.x = Math.cos(deg) * distance;
  star.y = Math.sin(deg) * distance;
};

const app = new PIXI.Application({
  antialias: true, // default: false
  transparent: true, // default: false
  resolution: 1 // default: 1
});

//Get the texture for rope.
const starTexture = PIXI.Texture.fromImage(feather6Img);

const starAmount = 1000;
let cameraZ = 0;
const fov = 20;
const baseSpeed = 0.05;
let speed = 0;
const warpSpeed = 0;
const starStretch = 5;
const starBaseSize = 0.05;

//Create the stars
const stars = [];
for (let i = 0; i < starAmount; i++) {
  const star = {
    sprite: new PIXI.Sprite(starTexture),
    z: 0,
    x: 0,
    y: 0
  };
  star.sprite.alpha = 0.4;
  star.sprite.anchor.x = 0.5;
  star.sprite.anchor.y = 0.7;
  randomizeStar(star, true);
  app.stage.addChild(star.sprite);
  stars.push(star);
}

//Change flight speed every 5 seconds
// setInterval(() => {
//   // warpSpeed = warpSpeed > 0 ? 0 : 1;
// }, 5000);

// Listen for animate update
app.ticker.add(delta => {
  //Simple easing. This should be changed to proper easing function when used for real.
  speed += (warpSpeed - speed) / 20;
  cameraZ += delta * 10 * (speed + baseSpeed);
  for (let i = 0; i < starAmount; i++) {
    const star = stars[i];
    if (star.z < cameraZ) randomizeStar(star);

    //Map star 3d position to 2d with really simple projection
    const z = star.z - cameraZ;
    star.sprite.x = star.x * (fov / z) * app.renderer.screen.width + app.renderer.screen.width / 1.5;
    star.sprite.y = star.y * (fov / z) * app.renderer.screen.width + app.renderer.screen.height / 1.5;

    //Calculate star scale & rotation.
    const dxCenter = star.sprite.x - app.renderer.screen.width / 2;
    const dyCenter = star.sprite.y - app.renderer.screen.height / 2;
    const distanceCenter = Math.sqrt(dxCenter * dxCenter + dyCenter + dyCenter);
    const distanceScale = Math.max(0, (2000 - z) / 2000);
    star.sprite.scale.x = distanceScale * starBaseSize;
    //Star is looking towards center so that y axis is towards center.
    //Scale the star depending on how fast we are moving, what the stretchfactor is and depending on how far away it is from the center.
    star.sprite.scale.y =
      distanceScale * starBaseSize +
      (distanceScale * speed * starStretch * distanceCenter) / app.renderer.screen.width;
    star.sprite.rotation = Math.atan2(dyCenter, dxCenter) + Math.PI / 2;
  }
});

export default class Star extends PureComponent {
  constructor(props) {
    super(props);
    this.starRef = React.createRef();
  }
  componentDidMount() {
    window.addEventListener("resize", this.onResize);
    setTimeout(() => {
      this.animateStar();
    }, 1);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }
  onResize = e => {
    const { parent } = this.props;
    app.renderer.resize(parent.current.offsetWidth, parent.current.offsetHeight);
  };
  animateStar = () => {
    const { parent } = this.props;
    if (parent.current) {
      app.renderer.autoResize = true;
      app.renderer.resize(parent.current.offsetWidth, parent.current.offsetHeight);
      this.starRef.current.appendChild(app.view);
    }
  };
  render() {
    return <StarStyled className="star-component" innerRef={this.starRef} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Star.js